






  import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
  import AnnalsStartView from './annals-start.vue';

  enum ANNALS_SETP {
  START = "AnnalsStartView",
}

@Component({
  components: {
    AnnalsStartView: AnnalsStartView,
  },
})
export default class AnnalsView extends Vue {
  private annalsSetp = ANNALS_SETP.START;

  @Watch("child")
  onChildChanged(val: string, oldVal: string) {}

  // prop定义
  @Prop() private propMessage: any = null;
  //$refs定义
  @Ref("refs")
  private refs!: HTMLElement;
  //事件发送
  @Emit("myEvent")
  private myEvent() {
    this.$set
  }

  //data数据
  public msg = 123;

  // 普通方法
  greet() {}

  // 计算属性
  get computedMsg(): any {
    return null;
  }
}
